<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'common.title_info_date'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('back')"
  />
</template>

<script>
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";

export default {
  name: "InvoiceManagementRightPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return [
        {
          labelKey: "stock_management.invoice_management.invoice_date",
          path: "date",
          required: true,
        },
        {
          labelKey: "stock_management.invoice_management.due_date",
          path: "due_date",
          required: true,
        },
        {
          labelKey: "common.unit",
          path: "department_name",
          required: true,
        },
        {
          labelKey: "common.partner",
          path: "partner_name",
          required: true,
        },
        {
          labelKey: "stock_management.invoice_management.invoice_number",
          path: "invoice_number",
          required: true,
        },
        {
          labelKey: "stock_management.invoice_management.vat",
          path: "vat_code",
          required: true,
          formatter: (val) => {
            if (val === null || val === undefined || val === "") return "*";
            return "" + val + "%";
          },
        },
        {
          labelKey: "stock_management.invoice_management.reception_item_number",
          path: "items",
          required: true,
          formatter: (val) => {
            const count = Array.isArray(val) ? val.length : 0;
            if (!count) return "*";
            return "" + count + (count === 1 ? " item selectat" : " items selectate");
          },
        },
      ];
    },
  },
};
</script>
